import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';

@Pipe({
    name: 'asFormArray',
    standalone: false
})

export class CastToFormArrayPipe implements PipeTransform {
  public transform(item: AbstractControl): FormArray {
    return (item as FormArray);

  }
}
